// extracted by mini-css-extract-plugin
export default {"main":"page-contacts_main__ixwTL","contIcon":"page-contacts_contIcon__vjm5K","contacts":"page-contacts_contacts__5fi80","item":"page-contacts_item__YkxXf"};